import React, { PureComponent } from "react";
import { Helmet } from "react-helmet";


import List from "../../../../../Components/List/List";
import ContainerHeader from "../../../../../Components/ContainerHeader";
import Navbar from "../../Navbar";
import localize from "helpers/localize";

class BannedCashregistersList extends PureComponent {
  render() {
    return (
      <div className="animated slideInUpTiny animation-duration-3">
        <Helmet>
          <title>{localize("cashregisters", "Tiltott AP számok")}</title>
        </Helmet>
        <Navbar {...this.props} />
        <ContainerHeader
          title={localize("cashregisters", "Tiltott AP számok")}
        />
        <List {...this.props} disableViewIcon={true} />
      </div>
    );
  }
}

export default BannedCashregistersList;



// WEBPACK FOOTER //
// ./src/Containers/Pages/Cashregisters/BannedCashregisters/views/BannedCashregistersList.js